export class TopToolbarTextDataEN {
    static readonly htmlLabel = {
        welcome: 'Welcome',
        orgAdmin: '(Organization Admin)',
        deptAdmin: '(Department Admin)',
        licenseExpired: 'Your license has expired. Please contact support!',
        toolBoxPrepTraining: 'PREP Training',
        toolBoxQuickStartGuide: 'Quick Start Guide',
        notificationHeading: 'Notifications',
        notficationPart1Text: 'You have ',
        notificationPart2Text: ' new notifications.',
        notificationFineText: 'All fine! No notifications right now.',
        notificationMarkRead: 'Mark all as read',
        resourceText: 'PREP Resources',
        resourceTutorial: 'PREP Training',
        resourceOnboardDoc: 'Quick Start Guide',
        resourceVideo: 'PREP Videos',
        resourceVideoSubmenuItem1: 'Getting Started with the PREP Tool',
        resourceVideoSubmenuItem2: 'Using the Remediation Tag Editor',
        resourceVideoSubmenuItem3: 'Understanding Tagging Types',
        resourceVideoSubmenuItem4: 'General Information and Guidelines',
        resourceVideoSubmenuItem5: 'Configuring The PREP Account',
        userProfileText: 'Profile',
        userProfileLogoutText: 'Logout',
    };
    static readonly snackbarLabel = {

    };
    static readonly tooltipLabel = {
        toolBoxNotification: 'NOTIFICATION',
        resourceMenu: 'PREP Resource Menu',
        toolBoxPrepTraining: 'PREP TRAINING',
        toolBoxHelp: 'HELP',
        toolBoxFullScreen: 'FULL SCREEN',
        toolBoxReleaseNotes: 'RELEASE NOTES',
        toolBoxUserProfile: 'USER PROFILE MENU',

    }
}
